// 工作人员确认 两融专员确认
// propData: { title: "", messageText: "" }
<template>
  <div class="user-auth-box">
    <div class="user-auth-title">{{ propData.title }}</div>
    <div class="user-auth-message">{{ propData.messageText }}</div>
  </div>
</template>
<script>

export default {
  props: {
    propData: {
      type: Object,
      default: {
        title: "请工作人员确认以下内容",
        messageText: ""
      }
    }
  },
  data () {
    return {};
  }
};
</script>
<style lang="less" scoped>
.user-auth-box {
  width: 100%;
  height: 100%;
  .user-auth-title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 130px 0 100px;
    font-size: 56px;
    font-weight: bold;
    line-height: 52px;
    color: #232323;
    &::before,
    &::after {
      content: "";
      display: block;
      width: 24px;
      height: 18px;
    }
    &::before {
      margin-right: 20px;
      background-image: url("~@img/home/05option/icon_zuo.png");
    }
    &::after {
      margin-left: 20px;
      background-image: url("~@img/home/05option/icon_you.png");
    }
  }
  .user-auth-message {
    margin: 0 auto;
    padding: 64px;
    width: 1000px;
    min-height: 350px;
    font-size: 30px;
    font-weight: 500;
    color: #4a4e53;
    line-height: 48px;
    background: #f5f7f8;
    border: 1px solid #dee1ea;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/lib/ui/default/popup/src/content/userAuth.vue